import { render, staticRenderFns } from "./ListBoItem.vue?vue&type=template&id=fce189fc&scoped=true&"
import script from "./ListBoItem.vue?vue&type=script&lang=js&"
export * from "./ListBoItem.vue?vue&type=script&lang=js&"
import style0 from "./ListBoItem.vue?vue&type=style&index=0&id=fce189fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce189fc",
  null
  
)

export default component.exports